export const stringToId = (str) => str.replace(/\s/g, ``);
